export enum PaymentProviderEnum {
  STRIPE = "STRIPE",
  PAYPAL = "PAYPAL"
}
